























import Vue from "vue";
import Component from "vue-class-component";
import { ValidateImportProductError } from "@/models/mutations/ValidateImportProducts";

@Component({
  props: {
    errors: Array
  }
})
export default class ImportErrorTable extends Vue {
  private errors!: [ValidateImportProductError][];
}
